// extracted by mini-css-extract-plugin
module.exports = {"breakpoint_small":"640","breakpoint_medium":"1024"};